import { ScrollReveal } from '@/components/ui/ScrollReveal';
import { useTranslation } from 'react-i18next';

export const Fire = () => {
  const { t } = useTranslation('home');

  return (
    <section id="fuoco" className="relative min-h-screen overflow-hidden" aria-labelledby="fuoco-heading">
      <div className="absolute inset-0">
        <img
          src="/img/DSC09272 (2024-04-22T17_55_41.962).JPG"
          alt={t('fire.imageAlt')}
          className="h-full w-full object-cover"
          loading="lazy"
          decoding="async"
          width="1200"
          height="800"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent" />
      </div>

      <div className="relative z-10 flex min-h-screen items-center px-6 py-32">
        <div className="mx-auto max-w-7xl">
          <div className="max-w-xl">
            <ScrollReveal>
              <span className="mb-4 inline-block text-sm font-light uppercase tracking-[0.3em] text-primary">
                {t('fire.label')}
              </span>
            </ScrollReveal>

            <ScrollReveal delay={100}>
              <h2 id="fuoco-heading" className="mb-8 text-5xl font-bold text-foreground md:text-6xl lg:text-7xl">
                {t('fire.title')}
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <p className="mb-6 text-xl font-light leading-relaxed text-muted-foreground">{t('fire.text1')}</p>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <p className="text-xl font-light leading-relaxed text-muted-foreground">{t('fire.text2')}</p>
            </ScrollReveal>

            <ScrollReveal delay={400}>
              <div className="mt-12 flex items-center gap-8">
                <div>
                  <span className="block text-3xl font-bold text-primary">{t('fire.tag1a')}</span>
                  <span className="text-sm uppercase tracking-wider text-muted-foreground">{t('fire.tag1b')}</span>
                </div>
                <div className="h-12 w-[1px] bg-border" />
                <div>
                  <span className="block text-3xl font-bold text-primary">{t('fire.tag2a')}</span>
                  <span className="text-sm uppercase tracking-wider text-muted-foreground">{t('fire.tag2b')}</span>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
};
